<template>
  <Modal :modelValue="modelValue" @on-visible-change="visibleChange" class="modal-top" :width="70" :loading="loading">
    <template #header>
      分类编辑
    </template>
    <Row type="flex" style="height: 100%;">
      <Col :span="8" >
        <Card class="fixed-side" style="height: 100%;margin: 0 10px 0 0;">
          <template #title>
            <Input v-model="lastQuery"  style="margin-bottom: 8px" clearable placeholder="请输入字典码(区分大小写)名称进行查询"/>
          </template>
          <Menu
            style="width: 100%;height: calc(100vh - 278px);overflow: auto;"
            :active-name="selectedKey"
            @on-select="onShowDetail"
            mode="vertical"
            theme="light"
          >
            <item :tree="tree" :opend="opend" :lastQuery="lastQuery" :selectedKey="selectedKey" @loadChild="loadChild"></item>
          </Menu>
          <div class="card-footer">
            <ul class="card-actions">
              <li >
                <Button type="text" ghost class="action" icon="md-add-circle" title="新增根字典" @click.stop="onAddRoot">新增根字典</Button>
              </li>
              <li >
                <Button type="text" ghost class="action" icon="md-add-circle" :title="selected && selected.pid ? '为选中的【根字典】，添加【子字典】' : '请先选择【根字典】'" :disabled="!selected" @click.stop="onAddChildRoot">新增子字典</Button>
              </li>
            </ul>
          </div>
        </Card>
      </Col>
      <Col :span="16" class="scroll-side">
        <Card
          :loading="!loading"
          class="fixed-side"
          style="height: 100%;"
        >
          <template #title>
            <span v-if="form.id" key="edit">
              <Icon type="ios-create" />
              &nbsp;
              {{ $t('toolbar.edit') }} 【{{form.name}}】 字典
            </span>
            <span v-else key="add">
              <Icon type="md-add" />
              &nbsp;
              {{ $t('toolbar.add') }} {{this.form && this.selected && this.form.pid == this.selected.id ? "【" + this.selected.name + "】子字典" : "到根字典"}}
            </span>
          </template>
          <Alert type="error" v-if="form && form.isfixed">{{"【" + this.selected.name + "】字典为系统默认项，禁止修改"}}</Alert>
          <Form v-if="!loading" :model="form" :rules="rules" ref="dictEditModelForm" class="edit-form" :label-width="100">
            <FormItem :label="$t('form.name')" prop="name">
              <Input v-model="form.name" :disabled="!!form.isfixed" placeholder="请填写名称"></Input>
            </FormItem>
            <FormItem :label="$t('form.code')" prop="code">
              <Input v-model="form.code" :disabled="!!form.isfixed || form.id" placeholder="请填写编号/编码,保存后禁止修改">
                <template #prepend v-if="parentDict" >
                  <span title="子编码要携带父编码，用以表示层级结构">{{parentDict.code}}</span>
                </template>
              </Input>
            </FormItem>
            <FormItem :label="$t('form.alias')" prop="alias">
              <Input v-model="form.alias" :disabled="!!form.isfixed" placeholder="请填写别名"></Input>
            </FormItem>
            <FormItem :label="$t('form.sort')" prop="sort">
              <InputNumber v-model="form.sort" :disabled="!!form.isfixed" placeholder="请填写排序号，从大到小排列" :min="1" :max="50000" />
            </FormItem>
            <FormItem :label="$t('form.bewrite')" prop="bewrite">
              <Input v-model="form.bewrite" :disabled="!!form.isfixed" placeholder="请填写备注"></Input>
            </FormItem>
          </Form>
          <div class="card-footer">
            <ul class="card-actions">
              <li >
                <Button type="text" ghost class="action error" icon="md-remove-circle" title="禁用" v-if="(form.status == 9)" :disabled="(!!form.isfixed && !!form.id)" @click.stop="onDisable">禁用</Button>
                <Button type="text" ghost class="action success" icon="md-checkmark-circle" title="启用" v-if="(form.status == 0)" :disabled="(!!form.isfixed && !!form.id)" @click.stop="onEnable">启用</Button>
              </li>
              <li >
                <Button type="text" ghost class="action" icon="ios-create" title="保存" :disabled="!!form.isfixed" @click.stop="onSubmit">保存</Button>
              </li>
            </ul>
          </div>
        </Card>
      </Col>
    </Row>
    <template #footer>
      <Button type="primary" :loading="loadingSubmit" @click="$emit('update:modelValue', false)">确认完成</Button>
    </template>
  </Modal>
</template>
<script>
import item from '@/views/pc/setting/dict/item'
import { arrayToTree } from "@/utils";
export default {
  name: 'DictEditModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    preCode: {
      type: String,
      default: ''
    },
    pid: {
      type: String,
      default: ''
    },
    pCode: { // 用于获取所有符合要求的pcode
      type: String,
      required: true
    },
  },
  data() {
    return {
      lastQuery: '',
      selected: undefined,
      selectedKey: undefined,
      default: {
        name: null,
        alias: null,
        isFixed: 0,
        sort: 10,
        status: 1
      },
      opend: [],
      form: {},
      rules: {
        name: [{ required: true, message: '请填写名称' }],
        code: [{ required: true, message: '请填写编码' }, {validator : this.codeValidator, trigger: 'blur' }],
        alias: [{ required: true, message: '请填写别名' }],
        sort: [{ required: true, type: 'integer', message: '请填写排序号，从大到小排列，最小 1，最大 50000' }],
        // bewrite: [{ required: true, message: '请填写备注' }]
      },
      loadingSubmit: false,
      loading: false,
      url: {
        save: '/manage/dictionary/modify',
        update: '/manage/dictionary/modify'
      }
    }
  },
  computed: {
    list() {
      if (this.pid) {
        return this.$store.state.app.dictionaryList.filter( 
          (d) => d.id != this.pid && d.code.startsWith(this.pCode)
        ).map(row => { return { ...row, title: row.name, key: row.id } });
      }
    },
    tree() {
      return arrayToTree(this.list)
    },
    parentDict() {
      return !this.pid ? null : this.$store.state.app.dictionaryList.find(row => row.id === (this.form && this.form.pid ? this.form.pid : this.pid))
    },
  },
  methods: {
    visibleChange(value) {
      if (value) {
        this.init()
      } else {
        this.$emit('update:modelValue', false)
        this.loading = true
      }
    },
    loadChild(event, id, pid) {
      if (this.opend.includes(id)) {
        this.opend.splice(this.opend.indexOf(id), 1);
      } else {
        this.opend.push(id)
      }
    },
    // onSearchDict(value) {
      // this.lastQuery = value
    // },
    codeValidator(rule, value, callback) {
      if (value) {
        this.$http({
          url: '/manage/dictionary/exist-code/' + (this.parentDict ? this.parentDict.code + value : value) + (this.form.id ? '?id=' + this.form.id : ''),
          method: 'GET'
        }).then(response => {
          if (response.code === 200) {
            // this.$Message.info('编号可以使用')
            callback()
          } else if (response.code === 409) {
            callback(new Error('已经存在'))
          } else {
            callback(new Error('未知错误'))
          }
        })
      } else {
        callback()
      }
    },
    onShowDetail(id) { // 选择字典
      this.loading = true
      this.selected = this.list.find(dict => dict.id == id)
      this.selectedKey = id
      this.form = {
        ...this.selected,
      }
      this.$nextTick(() => {
        this.form.code = this.parentDict ? this.selected.code.replace(this.parentDict.code, '') : this.selected.code
        this.loading = false
      })
    },
    onAddRoot() { // 新增根字典
      this.form = { preCode: this.preCode, pid: this.pid }
    },
    onAddChildRoot() { // 新增子字典
      this.form = { pid: this.selected.id, preCode: this.preCode }
    },
    onDisable() {
      if (this.form && this.form.id) {
        if (this.form.isfixed) {
          this.$Message.warning("系统默认项，禁止修改编辑");
        } else {
          this.$Modal.confirm({
            title: '提示',
            content: '确定要禁用 ' + this.form.name + ' 吗？',
            onOk: () => {
              this.loadingSubmit = true
              this.$http({
                url: '/manage/dictionary/disable/' + item.id,
                method: 'GET'
              }).then(response => {
                if (response.code == 200) {
                  this.$Message.success(response.msg)
                  this.loading = true
                  this.$store.dispatch('FETCH_DICTIONARY_LIST', { force: true }).then(() => {
                    this.loading = false
                  })
                }
                this.loadingSubmit = false
              })
            }
          })
        }
      } else {
        this.$Message.warning("请选择有效的字典，再进行此操作");
      }
    },
    onEnable() {
      if (this.form && this.form.id) {
        if (this.form.isfixed) {
          this.$Message.warning("系统默认项，禁止修改编辑");
        } else {
          this.$Modal.confirm({
            title: '提示',
            content: '确定要启用 ' + this.form.name + ' 吗？',
            onOk: () => {
              this.loadingSubmit = true
              this.$http({
                url: '/manage/dictionary/enable/' + this.form.id,
                method: 'GET'
              }).then(response => {
                if (response.code == 200) {
                  this.$Message.success(response.msg)
                  this.loading = true
                  this.$store.dispatch('FETCH_DICTIONARY_LIST', { force: true }).then(() => {
                    this.loading = false
                  })
                }
                this.loadingSubmit = false
              })
            }
          })
        }
      } else {
        this.$Message.warning("请选择有效的字典，再进行此操作");
      }
    },
    onSubmit() {
      this.$refs['dictEditModelForm'].validate(valid => {
        if (valid) {
          this.loadingSubmit = true
          this.$http({
            url: this.url.save,
            method: 'POST',
            data: {
              ...this.form,
              code: this.parentDict ? this.parentDict.code + this.form.code : this.form.code
            }
          }).then(response => {
            if (response.code === 200) {
              this.$Message.success(response.msg)
              this.loading = true
              this.$store.dispatch('FETCH_DICTIONARY_LIST', { force: true }).then(() => {
                this.loading = false
              })
            }
            this.loadingSubmit = false
          })
        } else {
          this.$Message.error('表单验证未通过，请按提示修改后重试')
        }
      })
    },
    init() {
      this.form = { ...this.default, preCode: this.preCode, pid: this.pid }
      this.$store.dispatch('FETCH_DICTIONARY_LIST').then(() => {
      })
      this.loading = false
    }
  },
  components: {
    item
  }
}
</script>
